// this is used to supply an encoded value for a url filter query
// to avoid caching issues when fetching a CMS page via url.
// separated into a util for easier updating in the future
const encodedUrlFilterQuery = encodeURIComponent('filters[url][$eq]');

export default encodedUrlFilterQuery;
